<template>
  <section>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'app-settings-content'
}
</script>
